module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ata0F"))).then(() => parcelRequire('9Lwss'));